if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomIndex = 0;
        this.querySelector('[data-lf-zoom-prev]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.go(this.zoomIndex - 1);
        });
        this.querySelector('[data-lf-zoom-next]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.go(this.zoomIndex + 1);
        });
        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowRight') this.go(this.zoomIndex + 1);
          if (event.code === 'ArrowLeft') this.go(this.zoomIndex - 1);
        });
        this.track = this.querySelector('.lf-zoom-track');
        this.track?.addEventListener(
          'scroll',
          () => {
            if (this.zoomScrolling) return;
            window.requestAnimationFrame(() => this.syncFromScroll());
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      visibleSlides() {
        const slides = [...(this.track?.children || [])];
        const firstVariant = slides.find((slide) => slide.classList.contains('product__media-item--variant'));
        return slides.filter((slide) => {
          if (!slide.classList.contains('product__media-item--variant')) return true;
          return slide === firstVariant;
        });
      }

      showActiveMedia() {
        const slides = this.visibleSlides();
        const activeId = this.openedBy?.getAttribute('data-media-id');
        let index = slides.findIndex((slide) => slide.getAttribute('data-media-id') === activeId);
        if (index < 0) index = 0;
        slides.forEach((slide) => slide.classList.add('active'));
        this.go(index, 'auto');

        const activeMedia = slides[index];
        const activeMediaTemplate = activeMedia?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      go(index, behavior = 'smooth') {
        const slides = this.visibleSlides();
        if (!slides.length || !this.track) return;
        const next = (index + slides.length) % slides.length;
        this.zoomIndex = next;
        this.zoomScrolling = true;
        this.track.scrollTo({ left: slides[next].offsetLeft, behavior });
        window.setTimeout(() => {
          this.zoomScrolling = false;
        }, behavior === 'smooth' ? 400 : 40);
        this.updateCount(slides);
      }

      syncFromScroll() {
        const slides = this.visibleSlides();
        if (!slides.length || !this.track) return;
        const width = this.track.clientWidth || 1;
        const index = Math.round(this.track.scrollLeft / width);
        this.zoomIndex = Math.min(slides.length - 1, Math.max(0, index));
        this.updateCount(slides);
      }

      updateCount(slides = this.visibleSlides()) {
        const count = this.querySelector('[data-lf-zoom-count]');
        const prev = this.querySelector('[data-lf-zoom-prev]');
        const next = this.querySelector('[data-lf-zoom-next]');
        const multiple = slides.length > 1;
        if (count) {
          count.hidden = !multiple;
          count.textContent = multiple ? `${this.zoomIndex + 1} / ${slides.length}` : '';
        }
        if (prev) prev.hidden = !multiple;
        if (next) next.hidden = !multiple;
      }
    }
  );
}
